function GridRow({ cells, testId }) {
  return (
    <div className="contents" data-testid={testId}>
      {cells.map((cell, idx) => (
        <span key={idx} className="items-center">
          {cell}
        </span>
      ))}
    </div>
  );
}

export default GridRow;
